<template>
  <el-popover
      :visible="visible"
      placement="top"
      :width="width"
      trigger="manual"
      @update:visible="handleVisibleChange"
  >
    <div class="confirm-delete-popover">
      <!--      <el-icon>-->
      <!--        <WarningFilled/>-->
      <!--      </el-icon>-->
      <p>{{ message }}</p>
    </div>
    <div style="text-align: center; margin-top: 8px">
      <el-button size="small" @click="cancel">{{ $t('common.sss16') }}</el-button>
      <el-button size="small" type="primary" @click="confirm">{{ $t('common.confirm') }}</el-button>
    </div>
    <template #reference>
      <span class="confirm-delete-popover__reference" @click.capture="handleReferenceClick">
        <slot name="settings"></slot>
      </span>
    </template>
  </el-popover>
</template>

<script setup>
const props = defineProps({
  visible: Boolean,
  width: [String, Number],
  message: String,
});

const emit = defineEmits();

const handleVisibleChange = (value) => {
  emit("update:visible", value);
};

const handleReferenceClick = () => {
  if (!props.visible) {
    emit("update:visible", true);
  }
};

const cancel = () => {
  emit("update:visible", false);
};

const confirm = () => {
  emit("confirm:delete");
  cancel();
};
</script>

<style lang="less" scoped>
.confirm-delete-popover {
  display: flex;
  justify-content: center;
  align-items: center;

  & > .el-icon {
    color: #faad14;
    margin-right: 2px;
  }
}

.confirm-delete-popover__reference {
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
}
</style>
